export let TextFragmentUtils = class TextFragmentUtils {
    static generatePreAndPostContent = (selection) => {
        const selectedText = selection.toString().trim();

        if (!selectedText) return { preContent: "", postContent: "" };

        const wordLength = 10; // Number of words to capture around the selected text

        // Extract surrounding context to
        const range = selection.getRangeAt(0);
        const textStartNodeText = range.startContainer.textContent || "";
        const textEndNodeText = range.endContainer.textContent || "";

        const prefix = textStartNodeText.substring(0, range.startOffset).trim();
        const suffix = textEndNodeText.substring(range.endOffset).trim();

        // Shorten prefix and suffix to the last wordLength
        let effectivePrefix = prefix.split(" ").slice(-wordLength).join(" ");
        let effectiveSuffix = suffix.split(" ").slice(0, wordLength).join(" ");

        // Remove initial space if exists on prefix
        if (effectivePrefix.startsWith(" "))
            effectivePrefix = effectivePrefix.substring(1);

        // When user selects text from beginning of a text node, the prefix is empty
        // and the suffix is the entire text node. In this case, we want to use the
        // parent node's text as fallback if no effective prefix/suffix
        // HINT: This is for future use when we want to capture more context

        // if (!effectivePrefix && range.startContainer.parentNode) {
        //   effectivePrefix = range.startContainer.parentNode.textContent.split(" ").slice(-wordLength).join(" ");
        // }
        // if (!effectiveSuffix && range.endContainer.parentNode) {
        //   effectiveSuffix = range.endContainer.parentNode.textContent.split(" ").slice(0, wordLength).join(" ");
        // }

        return {
            preContent: effectivePrefix || "",
            postContent: effectiveSuffix || "",
            //highlightLink: highlightLink
        };
    };
};
